import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { callAPI } from "../../../lib/common";
import { DialogActions, DialogContent } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Popup, {
  PopupContent,
  PopupHeading,
  PopupTextContent,
} from "../../../components/Common/Popup";
import Box from "@material-ui/core/Box";
import TextField from "./TextField";
import LoadingButton from "../../../components/LoadingButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../components/Common/FormikTextField";

const useStyles = makeStyles((theme) => ({
  codeTextField: {
    marginRight: theme.spacing(2),
    flexBasis: 1,
    flexGrow: 1,
    margin: 0,
  },
  button: {
    flexBasis: 1,
    flexGrow: 1,
  },
}));

const ForgotPasswordDialog = ({ email, onClose }) => {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [completeMessage, setCompleteMessage] = useState("");
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Popup open={true} onClose={onClose}>
      <PopupHeading>
        <Trans>Forgot your password?</Trans>
      </PopupHeading>

      <PopupContent>
        <Formik
          initialValues={{
            emailAddress: "",
          }}
          validateOnMount={true}
          validationSchema={formSchema(t)}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            setSending(true);
            setError("");
            const email = encodeURIComponent(values.emailAddress);
            callAPI(
              `/sections/prophoto/ajax/send_password_reminder.php?json=1&email=${email}`
            )
              .then((res) => {
                if (res.error) {
                  setError(res.error);
                } else {
                  setCompleteMessage(res.message);
                }
              })
              .catch((err) => {
                setError(t("Error sending password reset instructions."));
              })
              .finally(() => {
                setSending(false);
              });
          }}
        >
          {({ submitForm, isValid, isSubmitting }) => {
            return (
              <Form className={classes.form}>
                {error && (
                  <p style={{ color: "red", textAlign: "center" }}>{error}</p>
                )}
                {!completeMessage && (
                  <>
                    <p>
                      <Trans>
                        Enter your e-mail address below, and an email with a
                        link to reset your password will be sent immediately.
                      </Trans>
                    </p>
                    <Box display="flex" justifyContent="center" mt={2}>
                      <Box maxWidth={500} display="flex">
                        <Field
                          component={FormikTextField}
                          label={t("Email address")}
                          variant="outlined"
                          className={classes.codeTextField}
                          type="email"
                          name="emailAddress"
                        />
                        <LoadingButton
                          isLoading={sending}
                          disabled={!isValid}
                          className={classes.button}
                          variant="primary"
                        >
                          <Trans>Send reset instructions</Trans>
                        </LoadingButton>
                      </Box>
                    </Box>
                  </>
                )}
                {completeMessage && (
                  <div>
                    <p>{completeMessage}</p>
                    <Button
                      onClick={onClose}
                      color="primary"
                      variant="outlined"
                    >
                      <Trans>Close</Trans>
                    </Button>
                  </div>
                )}
              </Form>
            );
          }}
        </Formik>
      </PopupContent>
    </Popup>
  );
};

const formSchema = (t) => () => {
  return Yup.object().shape({
    emailAddress: Yup.string()
      .email(t("Invalid email"))
      .required(t("This is required!")),
  });
};

export default ForgotPasswordDialog;
